<template>
  <div v-if="links && links.pages && Object.keys(links.pages).length > 0">
    <div class="flex flex-wrap">
      <!-- First and Previous buttons -->
      <button class="mr-1 mb-1 px-4 py-3 text-sm border rounded" :disabled="!links.first.url" @click="changePage(links.first.url)">
        {{ links.first.label }}
      </button>
      <button class="mr-1 mb-1 px-4 py-3 text-sm border rounded" :disabled="!links.prev.url" @click="changePage(links.prev.url)">
        {{ links.prev.label }}
      </button>

      <!-- Page number buttons with ellipsis -->
      <template v-for="(page, key) in computedPageLinks" :key="key">
        <button v-if="page.url" class="mr-1 mb-1 px-4 py-3 text-sm border rounded" :class="{ 'bg-gray-300': page.active }" @click.prevent="changePage(page.url)">
          {{ page.label }}
        </button>
        <span v-else class="mr-1 mb-1 px-4 py-3 text-sm border rounded">...</span>
      </template>

      <!-- Next and Last buttons -->
      <button class="mr-1 mb-1 px-4 py-3 text-sm border rounded" :disabled="!links.next.url" @click="changePage(links.next.url)">
        {{ links.next.label }}
      </button>
      <button class="mr-1 mb-1 px-4 py-3 text-sm border rounded" :disabled="!links.last.url" @click="changePage(links.last.url)">
        {{ links.last.label }}
      </button>
    </div>
  </div>
</template>

  <script>
export default {
  props: {
    links: Object,
  },
  computed: {
    computedPageLinks() {
      if (!this.links || !this.links.pages) return [] // Prevent undefined or null error

      const currentPage = this.links.current_page
      const totalPages = this.links.total_pages
      const delta = 2 // Number of pages to show before/after the current page
      let range = []
      let rangeWithDots = []
      let lastPage

      for (let i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
          range.push(i)
        }
      }

      for (let i of range) {
        if (lastPage) {
          if (i - lastPage === 2) {
            rangeWithDots.push({ label: lastPage + 1, url: this.links.pages[lastPage + 1] })
          } else if (i - lastPage !== 1) {
            rangeWithDots.push({ label: '...', url: null })
          }
        }
        rangeWithDots.push({ label: i, url: this.links.pages[i], active: i === currentPage })
        lastPage = i
      }

      return rangeWithDots
    },
  },
  methods: {
    changePage(url) {
      if (url) {
        this.$emit('change-page', url)
      }
    },
  },
  //   mounted() {
  //     console.log('Pagination Links in Modal:', this.links) // Debugging: check if links are correctly passed
  //   },
}
</script>
